export const avatarColors = [
  {
    backgroundColor: "#F7F9FC",
    textColor: "#060A23",
    borderColor: "#ECF1F8",
  },
  {
    backgroundColor: "#EEEDFD",
    textColor: "#4409B9",
    borderColor: "#E5E4FC",
  },
  {
    backgroundColor: "#FFEBEE",
    textColor: "#BD0F2C",
    borderColor: "#FFE0E5",
  },
  {
    backgroundColor: "#FDEFE2",
    textColor: "#C56511",
    borderColor: "#FCE7D4",
  },
  {
    backgroundColor: "#E7F9F3",
    textColor: "#216E55",
    borderColor: "#DAF6ED",
  },
  {
    backgroundColor: "#EDEEFD",
    textColor: "#05128A",
    borderColor: "#DFE1FB",
  },
  {
    backgroundColor: "#ECFAFE",
    textColor: "#1F84A3",
    borderColor: "#DDF6FD",
  },
  {
    backgroundColor: "#F2FFD1",
    textColor: "#526E0C",
    borderColor: "#E2FF99",
  },
  {
    backgroundColor: "#FFF7E0",
    textColor: "#935F10",
    borderColor: "#FFF3D1",
  },
  {
    backgroundColor: "#FDF1F7",
    textColor: "#973562",
    borderColor: "#FCE9F2",
  },
];
